import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

/** Shown on a 403 (out-of-scope/role access). No data is revealed (architecture §4.3). */
export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="۴۰۳"
      subTitle="شما مجوز دسترسی به این بخش را ندارید."
      extra={
        <Button type="primary" onClick={() => navigate('/', { replace: true })}>
          بازگشت
        </Button>
      }
    />
  );
}
